// Stoke the Forges (§31 A10): the Propaganda Tower and the Efficiency Mandate.
//
// While both are the side's (`poweredCount`), it holds
// `ARTIFACTS_LATE.stokePoints` more Off-Turn Production — read beside
// `offTurnFor` at every round rollover (`endTurn`), so the ticks scale with
// the enemy factions alive that round like every other point. Derived from the
// board, never written into `run.offTurnPerSide`: a fallen Tower stops it at
// once. "You can only have one" is a placement door (`stokePlaceError`).

import type { Side } from "../board";
import { poweredCount } from "../industry/gear";
import { type IndustryState, PROPAGANDA_TOWER } from "../industry/state";
import { ARTIFACTS_LATE } from "../rules";

/** Off-Turn Production points `side`'s Stoke the Forges grants now. */
export const stokePoints = (industry: IndustryState, side: Side): number =>
  poweredCount(industry, side, PROPAGANDA_TOWER) * ARTIFACTS_LATE.stokePoints;

/**
 * Why `owner` may not place a Propaganda Tower, or null. One per side: an own
 * Tower standing, or a Mandate it powers (a stolen one included), refuses.
 */
export function stokePlaceError(industry: IndustryState, owner: Side): string | null {
  for (const structure of industry.structures.values()) {
    if (structure.kind === PROPAGANDA_TOWER && structure.owner === owner) {
      return "you can only have one Stoke the Forges";
    }
  }
  if (poweredCount(industry, owner, PROPAGANDA_TOWER) > 0) return "you can only have one Stoke the Forges";
  return null;
}
